import * as React from "react";

import { usePlpPresenterForTheSortingMenu } from "../providers";

import { Header } from "./Header";
import { Content } from "./Content";

const MobileSortingMenu_Controller: React.FunctionComponent = () => {
  const { showTheSortingMenu_onMobile } = usePlpPresenterForTheSortingMenu();

  if (!showTheSortingMenu_onMobile) {
    return null;
  }

  return <MobileSortingMenu_View></MobileSortingMenu_View>;
};

const MobileSortingMenu_View: React.FunctionComponent = () => {
  const { handleHideTheSortingMenu_onMobile } = usePlpPresenterForTheSortingMenu();

  React.useEffect(() => {
    if (window.matchMedia("(max-width: 1023px)").matches) {
      document.body.classList.add("bbnt-modal-visible-scroll-that-only");
    } else {
      handleHideTheSortingMenu_onMobile();
      document.body.classList.remove("bbnt-modal-visible-scroll-that-only");
    }

    const handleResize = () => {
      if (window.matchMedia("(min-width: 1024px)").matches) {
        handleHideTheSortingMenu_onMobile();
        document.body.classList.remove("bbnt-modal-visible-scroll-that-only");
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.body.classList.remove("bbnt-modal-visible-scroll-that-only");
    };
  }, []);

  return (
    <aside
      className="modal-container sorting"
      ref={(element) => element && element.focus()}
    >
      <div className="overlay" />
      <div className="modal sorting">
        <Header />
        <Content />
      </div>
    </aside>
  );
};

export const MobileSortingMenu = MobileSortingMenu_Controller;
